/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable sort-keys */

import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { GlobalSearchListItem } from '../models/global-search.model';
import { GlobalSearchService } from '../services/global-search.service';
import * as Selectors from '../state/global-search.selector';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-global-search',
    templateUrl: 'global-search.component.html',
    standalone: false
})
export class GlobalSearchComponent {
   @Output() itemSelectedCompleted = new EventEmitter<void>();

   @Output() clickedInside = new EventEmitter<Event>();

   accountSearchCallState$: Observable<CallState>;

   accountSearchResults$: Observable<GlobalSearchListItem[] | null>;

   deviceSearchCallState$: Observable<CallState>;

   deviceSearchResults$: Observable<GlobalSearchListItem[] | null>;

   phoneNumberSearchCallState$: Observable<CallState>;

   phoneNumberSearchResults$: Observable<GlobalSearchListItem[] | null>;

   softphoneUsernameSearchCallState$: Observable<CallState>;

   softphoneUsernameSearchResults$: Observable<GlobalSearchListItem[] | null>;

   GlobalSearchService: GlobalSearchService;

   constructor(private store: Store<AppState>) {
      this.accountSearchCallState$ = this.store.pipe(select(Selectors.selectAccountSearchCallState));
      this.accountSearchResults$ = this.store.pipe(select(Selectors.selectAccountsSearchResults));
      this.deviceSearchCallState$ = this.store.pipe(select(Selectors.selectDeviceSearchCallState));
      this.deviceSearchResults$ = this.store.pipe(select(Selectors.selectDevicesSearchResults));
      this.phoneNumberSearchCallState$ = this.store.pipe(select(Selectors.selectPhoneNumberSearchCallState));
      this.phoneNumberSearchResults$ = this.store.pipe(select(Selectors.selectPhoneNumbersSearchResults));
      this.softphoneUsernameSearchCallState$ = this.store.pipe(
         select(Selectors.selectSoftphoneUsernameSearchCallState)
      );
      this.softphoneUsernameSearchResults$ = this.store.pipe(select(Selectors.selectSoftphoneUsernamesSearchResults));
   }

   handleClickInsideSearch(event: Event): void {
      this.clickedInside.emit(event);
   }

   onItemSelected(): void {
      this.itemSelectedCompleted.emit();
   }
}
